export const NO_ACCESS = 0;
export const READ_ACCESS = 10;
export const EDIT_ACCESS = 20;
export const CREATE_ACCESS = 30;
export const DELETE_ACCESS = 40;

const roleNames = {
  [NO_ACCESS]: ['none'],
  [READ_ACCESS]: ['read'],
  [EDIT_ACCESS]: ['read', 'edit'],
  [CREATE_ACCESS]: ['read', 'edit', 'create'],
  [DELETE_ACCESS]: ['read', 'edit', 'create', 'delete'],
};

export const hasWriteAccess = (permission = []) =>
  permission.includes('edit') || permission.includes('create') || permission.includes('delete');

export const isReadOnlyPermission = (permission = []) =>
  permission.includes('read') && !hasWriteAccess(permission);

export const getPermission = (name, roles) => {
  return (roles && roleNames[roles[name]]) || ['none'];
}

export const isPermitted = (item, detailRole, ws, val) => {
  if (!(detailRole && detailRole.role)) {
    return false;
  }

  const profiles = getPermission('permissionProfiles', detailRole.role);
  const billing = getPermission('permissionBilling', detailRole.role);
  const users = getPermission('permissionUsers', detailRole.role);
  const deviceOS = getPermission('permissionOSUpdate', detailRole.role);
  const devices = getPermission('permissionDevices', detailRole.role);
  const applications = getPermission('permissionApplication', detailRole.role);
  const modules = getPermission('permissionModules', detailRole.role);
  const roles = getPermission('permissionRoles', detailRole.role);
  const workspace = getPermission('permissionWorkspace', detailRole.role);
  const terminalAccess = getPermission('permissionTerminalAccessManage', detailRole.role)
  const model = getPermission('permissionAIModel', detailRole.role);
  const dataset = ws && ws.datasetEnabled && getPermission('permissionDataset', detailRole.role);
  const video = getPermission('permissionDataCollection', detailRole.role);
  const imageAnnotation = getPermission('permissionImageAnnotation', detailRole.role);
  const modelTraining = getPermission('permissionModelTraining', detailRole.role);
  const terminal = getPermission('permissionTerminalAccessManage', detailRole.role);
  const videoViewer = getPermission('permissionVideoViewerManage', detailRole.role)
  const library = applications.concat(modules);
  const firstBlock = video.concat(imageAnnotation).concat(modelTraining).concat(model);
  const deployment = profiles.concat(devices);
  const audit = getPermission('permissionWorkspaceHistory', detailRole.role);
  const dashboards = ws && ws.dashboardsEnabled && getPermission('permissionDashboard', detailRole.role);
  const incidents = ws && ws.incidentsEnabled && getPermission('permissionIncidents', detailRole.role);
  const monitor = getPermission('permissionMonitoring', detailRole.role);
  const reports = ws && ws.reportsEnabled && getPermission('permissionReports', detailRole.role);
  const locations = getPermission('permissionLocations', detailRole.role);
  const aiInsights = getPermission('permissionAiInsights', detailRole.role);
  const appBuilder = getPermission('permissionAppBuilder', detailRole.role);
  const dashboardAgent = getPermission('permissionDashboardAgent', detailRole.role);
  const incidentAgent = getPermission('permissionIncidentAgent', detailRole.role);

  const permissionDetail = {
    profiles,
    deployment,
    library,
    devices,
    dataset,
    deviceOS,
    'devices-enrollment': devices,
    'device-configuration': devices,
    'device-management': devices,
    'members': users,
    'workspaceSettings': users,
    'myWorkspaceSettings': workspace,
    'aiContentCenter': workspace,
    'notificationDefaults': roles,
    users,
    profile: ['read'],
    myWorkspaces: ['read'],
    myProfile: ['read'],
    applications,
    permissionWorkspace: workspace,
    imageAnnotation,
    modelTraining,
    terminal,
    videoViewer: videoViewer,
    modules,
    videos: video,
    models: model,
    role: roles,
    terminalAccess: terminalAccess,
    authentication: workspace,
    workspace,
    reports,
    settings: ['read'],
    billing: (billing?.includes('read') && detailRole.role.type === 'system' && detailRole.role.name === 'Viso Support') ? ['read'] : null,
    audit,
    incidents,
    dashboards,
    monitor,
    planLimitsUsage: billing,
    marketplace: (detailRole.role.type === 'system' && detailRole.role.name === 'Viso Support') ? ['read'] : null,
    partner:  (detailRole.role.type === 'system' && detailRole.role.name === 'Viso Support') ? ['read'] : null,
    line: ['read'],
    back: ['read'],
    locations: locations.includes('edit') ? locations : null,
    'first-block': firstBlock,
    'second-block': library,
    'third-block': deployment,
    aiInsights,
    appBuilder,
    dashboardAgent,
    incidentAgent,
  };

  const permissions = permissionDetail[item.id] || ['none'];

  if (item.id === 'application-edit' && permissionDetail.applications.includes('create')) {
    return true;
  }

  if (permissions?.includes('read')) {
    return true;
  }

  return false;
};
